import React, { Component } from "react";
import { observe } from "mobx";
import Zendesk, { ZendeskAPI } from "react-zendesk";

import { colors } from "../../../assets";

const ZENDESK_KEY = "267751e2-b103-4486-b997-e86406350722";

class ZendeskWidget extends Component {
  onZendeskLoaded = () => {
    const { presenter } = this.props;

    presenter.onLoad();

    this.handleVisibility();
    this.handleLocale();
    this.handleLauncherButtonVisibility();
    this.handleSetSuggestions();
  };

  setAuthSettings = () => {
    const { viewModel } = this.props;
    const user = viewModel.user;

    if (process.env.REACT_APP_ENV !== "prod" || !user.token) return {};

    return {
      jwtFn: async callback => {
        const headers = new Headers({
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${user.token}`
        });

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/v1/zendesk/widget_jwt_auth`,
          {
            headers,
            body: "",
            method: "POST"
          }
        );

        if (response.ok) {
          const data = await response.json();

          callback(data.jwt);
        }
      }
    };
  };

  settings = () => {
    return {
      authenticate: {
        chat: {
          ...this.setAuthSettings()
        }
      },
      color: {
        theme: colors.primary.dark,
        launcher: "#fff",
        launcherText: colors.primary.dark
      },
      zIndex: -1 // To hide launcher button
    };
  };

  handlePrefill = (name, email) => {
    ZendeskAPI("webWidget", "prefill", {
      name: {
        value: name,
        readOnly: true
      },
      email: {
        value: email,
        readOnly: true
      }
    });
  };

  handleVisibility = () => {
    const { appViewModel } = this.props;

    observe(appViewModel, "supportVisible", supportVisible => {
      const visible = supportVisible.newValue;
      const event = visible ? "open" : "close";

      ZendeskAPI("webWidget", event);
    });
  };

  handleLocale = () => {
    ZendeskAPI("webWidget", "setLocale", "pt-br");
  };

  handleLauncherButtonVisibility = () => {
    this.showWidget();
    this.hideWidget();
  };

  showWidget = () => {


    ZendeskAPI("webWidget:on", "open", () => {
      const { presenter, viewModel } = this.props;

      presenter.showWidget();

      if (!viewModel.isLoggedOut && viewModel.user.name && viewModel.user.username) {
        this.handlePrefill(viewModel.user.name, viewModel.user.username)
      }

      setTimeout(() => {
        ZendeskAPI("webWidget", "updateSettings", {
          webWidget: {
            zIndex: 9999
          }
        });
      }, 150); // Prevent launcher button appearence show
    });
  };

  hideWidget = () => {
    const { presenter, viewModel } = this.props;

    ZendeskAPI("webWidget:on", "close", function() {
      presenter.hideWidget();

      ZendeskAPI("webWidget", "updateSettings", {
        webWidget: {
          zIndex: viewModel.isOnSignUp ? 9999 : -1 // Show launcher button when logged out
        }
      });
    });
  };

  handleSetSuggestions = () => {
    ZendeskAPI("webWidget", "helpCenter:setSuggestions", {
      search: "PDVend",
      url: true,
      labels: ["pdvend"]
    });
  };

  handleSignOutWidget = nextProps => {
    ZendeskAPI("webWidget", "updateSettings", {
      webWidget: {
        color: {
          launcher: "#fff",
          launcherText: colors.primary.dark
        },
        zIndex: nextProps.viewModel.isOnSignUp ? 9999 : -1 // Show launcher button when logged out
      }
    });
  }

  handleUserSession = nextProps => {
    if (nextProps.viewModel.isLoggedOut) {
      ZendeskAPI("webWidget", "logout");
      this.handleSetSuggestions();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (window.zE) { // Checks if Zendesk is initialized
      this.handleSignOutWidget(nextProps);
      this.handleUserSession(nextProps);
    }
  }

  render() {
    return (
      <Zendesk
        zendeskKey={ZENDESK_KEY}
        {...this.settings()}
        onLoaded={this.onZendeskLoaded}
      />
    );
  }
}

export default ZendeskWidget;



// WEBPACK FOOTER //
// ./src/components/support/zendesk-widget/view.jsx